var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName='src/es6Remx/connect.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _lodash=require('lodash.isfunction');var _lodash2=_interopRequireDefault(_lodash);
var _react=require('react');var _react2=_interopRequireDefault(_react);
var _custom=require('mobx-react/custom');
var _logger=require('./logger');var Logger=_interopRequireWildcard(_logger);
var _hoistNonReactStatics=require('hoist-non-react-statics');var _hoistNonReactStatics2=_interopRequireDefault(_hoistNonReactStatics);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}

var connect=function connect(mapStateToProps){
if((0,_lodash2.default)(mapStateToProps)){
return wrapWithObserverHigherOrderComponent(mapStateToProps);
}
return _custom.observer;
};

function wrapWithObserverHigherOrderComponent(mapStateToProps){
return function(Comp){
var wrappedComponent=observerOnMapStateToProps(Comp,mapStateToProps);
mergeStaticMembers(Comp,wrappedComponent);
return wrappedComponent;
};
}

function observerOnMapStateToProps(InnerComp,mapStateToProps){var
Hoc=function(_React$Component){_inherits(Hoc,_React$Component);
function Hoc(props){_classCallCheck(this,Hoc);var _this=_possibleConstructorReturn(this,(Hoc.__proto__||Object.getPrototypeOf(Hoc)).call(this,
props));

_this.originalComponentName=InnerComp.name;return _this;
}_createClass(Hoc,[{key:'render',value:function render()
{
Logger.startLoggingMapStateToProps();
var propsFromState=mapStateToProps(this.props);
Logger.endLoggingMapStateToProps(InnerComp.name,propsFromState);
var ObservedInnerComp=InnerComp;
return(
_react2.default.createElement(ObservedInnerComp,_extends({},this.props,propsFromState,{__source:{fileName:_jsxFileName,lineNumber:35}})));

}}]);return Hoc;}(_react2.default.Component);

return(0,_custom.observer)(Hoc);
}

function mergeStaticMembers(SrcComp,DestComp){
(0,_hoistNonReactStatics2.default)(DestComp,SrcComp);
}

module.exports={
connect:connect};